export default "__VITE_ASSET__x$$RE$n8__"